function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 12.4376V6.13333C32 4.95513 31.0449 4 29.8667 4H0V28.3333H29.8667C31.0449 28.3333 32 27.3782 32 26.2V19.8291C30.7247 19.0913 29.8667 17.7126 29.8667 16.1333C29.8667 14.5541 30.7247 13.1754 32 12.4376Z",
  fill: "url(#paint0_linear_20021958_75299)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 19.8845V12H6.66699V18.5101H10.0472V19.8845H5Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7921 20C13.1941 20 12.6769 19.873 12.2406 19.6189C11.8069 19.3622 11.4719 19.0055 11.2358 18.5486C10.9997 18.0892 10.8816 17.5566 10.8816 16.9509C10.8816 16.3401 10.9997 15.8062 11.2358 15.3494C11.4719 14.89 11.8069 14.5332 12.2406 14.2791C12.6769 14.0225 13.1941 13.8941 13.7921 13.8941C14.3901 13.8941 14.906 14.0225 15.3397 14.2791C15.7761 14.5332 16.1123 14.89 16.3484 15.3494C16.5845 15.8062 16.7026 16.3401 16.7026 16.9509C16.7026 17.5566 16.5845 18.0892 16.3484 18.5486C16.1123 19.0055 15.7761 19.3622 15.3397 19.6189C14.906 19.873 14.3901 20 13.7921 20ZM13.7998 18.7295C14.0719 18.7295 14.299 18.6526 14.4812 18.4986C14.6635 18.342 14.8008 18.129 14.8932 17.8595C14.9881 17.59 15.0356 17.2833 15.0356 16.9394C15.0356 16.5954 14.9881 16.2887 14.8932 16.0192C14.8008 15.7498 14.6635 15.5367 14.4812 15.3802C14.299 15.2236 14.0719 15.1453 13.7998 15.1453C13.5252 15.1453 13.2942 15.2236 13.1068 15.3802C12.922 15.5367 12.7822 15.7498 12.6872 16.0192C12.5948 16.2887 12.5486 16.5954 12.5486 16.9394C12.5486 17.2833 12.5948 17.59 12.6872 17.8595C12.7822 18.129 12.922 18.342 13.1068 18.4986C13.2942 18.6526 13.5252 18.7295 13.7998 18.7295Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9143 13.9711V15.2031H17.3532V13.9711H20.9143ZM18.1617 12.5544H19.8017V18.0674C19.8017 18.2188 19.8248 18.3369 19.871 18.4216C19.9172 18.5037 19.9814 18.5614 20.0635 18.5948C20.1482 18.6282 20.2457 18.6449 20.3561 18.6449C20.4331 18.6449 20.5101 18.6384 20.5871 18.6256C20.6641 18.6102 20.7231 18.5987 20.7642 18.591L21.0221 19.8114C20.94 19.837 20.8245 19.8665 20.6756 19.8999C20.5268 19.9358 20.3458 19.9577 20.1328 19.9654C19.7376 19.9808 19.3911 19.9281 19.0934 19.8075C18.7982 19.6869 18.5685 19.4995 18.4042 19.2454C18.24 18.9913 18.1591 18.6705 18.1617 18.283V12.5544Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.128 13.9711V15.2031H21.5669V13.9711H25.128ZM22.3754 12.5544H24.0154V18.0674C24.0154 18.2188 24.0385 18.3369 24.0847 18.4216C24.1309 18.5037 24.1951 18.5614 24.2772 18.5948C24.3619 18.6282 24.4594 18.6449 24.5698 18.6449C24.6468 18.6449 24.7238 18.6384 24.8008 18.6256C24.8778 18.6102 24.9368 18.5987 24.9779 18.591L25.2358 19.8114C25.1537 19.837 25.0382 19.8665 24.8893 19.8999C24.7405 19.9358 24.5595 19.9577 24.3465 19.9654C23.9512 19.9808 23.6047 19.9281 23.307 19.8075C23.0119 19.6869 22.7822 19.4995 22.6179 19.2454C22.4536 18.9913 22.3728 18.6705 22.3754 18.283V12.5544Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20021958_75299",
  x1: 0,
  y1: 4,
  x2: 23.711,
  y2: 33.9148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#755930"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.177083,
  stopColor: "#554328"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786458,
  stopColor: "#52422B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775D37"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20021958_75299",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.3 5.14062) rotate(155.185) scale(30.077 22.6323)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));
function SvgLotteryTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M32 12.4376V6.13333C32 4.95513 31.0449 4 29.8667 4H0V28.3333H29.8667C31.0449 28.3333 32 27.3782 32 26.2V19.8291C30.7247 19.0913 29.8667 17.7126 29.8667 16.1333C29.8667 14.5541 30.7247 13.1754 32 12.4376Z",
    fill: "url(#paint1_radial_20021958_75299)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.4376V6.13333C32 4.95513 31.0449 4 29.8667 4H0V28.3333H29.8667C31.0449 28.3333 32 27.3782 32 26.2V19.8291C30.7247 19.0913 29.8667 17.7126 29.8667 16.1333C29.8667 14.5541 30.7247 13.1754 32 12.4376Z",
    fill: "#DBC26A",
    style: {
      mixBlendMode: "overlay"
    }
  }), _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryTicket);
export default __webpack_public_path__ + "static/media/lotteryTicket.7230be38c2a5fb37b77502976e7106ea.svg";
export { ForwardRef as ReactComponent };